import queryString from 'querystring';
import Api from '../api';
import {
  CounterActivity,
  CounterChatMessage,
  CounterParams,
  CounterResponse,
} from '../../Components/Counters/types';

const VENDOR = `/users`;

const CountersAPI = {
  getVendorCounters(
    userId: number,
    {
      page = 1,
      pageSize = 10,
      vendorContacts,
      priorities,
      quoteStatus,
      prevSampleStatus,
      counterSampleStatus,
      sortOrder,
      sortedBy,
      counterIds,
      search,
      filters,
    }: CounterParams,
  ): Promise<CounterResponse> {
    const params = queryString.encode({
      page,
      pageSize,
      vendorContacts: vendorContacts.join(','),
      priorities: priorities.join(','),
      quoteStatus: quoteStatus.join(','),
      prevSampleStatus: prevSampleStatus.join(','),
      counterSampleStatus: counterSampleStatus.join(','),
      sortOrder: sortOrder?.toUpperCase(),
      sortedBy,
      counterIds,
      ...(search && { search }),
      ...(filters && { filters }),
    });
    return Api.get(`${VENDOR}/${userId}/counters?${params}`);
  },

  getCounterActivities(
    userId: number | string,
    counterId: string,
  ): Promise<CounterActivity[]> {
    return Api.get(`${VENDOR}/${userId}/counters/${counterId}/activities`);
  },

  getCounterChat(
    userId: number | string,
    counterId: string,
  ): Promise<CounterChatMessage[]> {
    return Api.get(`${VENDOR}/${userId}/counters/${counterId}/chat`);
  },

  /**
   * Edit quote for a counter
   * @param userId - The ID of the vendor
   * @param counterId - The ID of the counter
   * @param data - The quote data to update
   */
  editQuote(userId: number, counterId: string, data: unknown) {
    return Api.put(`${VENDOR}/${userId}/counters/${counterId}/quote`, {
      data,
    });
  },

  /**
   * Mark previous sample as received
   * @param userId - The ID of the vendor
   * @param counterId - The ID of the counter
   * @param data - The sample received data
   */
  markPrevSampleAsReceived(userId: number, counterId: string, data: unknown) {
    return Api.put(
      `${VENDOR}/${userId}/counters/${counterId}/prev-sample-received`,
      { data },
    );
  },

  /**
   * Mark counter sample as shipped
   * @param userId - The ID of the vendor
   * @param counterId - The ID of the counter
   * @param data - The sample shipped data
   */
  markCounterSampleAsShipped(userId: number, counterId: string, data: unknown) {
    return Api.put(`${VENDOR}/${userId}/counters/${counterId}/sample-shipped`, {
      data,
    });
  },

  /**
   * Update contacts for a counter
   * @param userId - The ID of the vendor
   * @param counterId - The ID of the counter
   * @param data - The contacts data to update
   */
  updateContacts(userId: number, counterId: string, data: unknown) {
    return Api.put(`${VENDOR}/${userId}/counters/${counterId}/contacts`, {
      data,
    });
  },
};

export default CountersAPI;
